import type { CipherText } from "@b2bportal/purchase-api";

export enum PaymentState {
  payment = "payment",
}

export interface UberPaymentContext {
  paymentSessionToken?: string;
  paymentQuoteToken?: CipherText;
}
export interface PaymentContext {
  [PaymentState.payment]: UberPaymentContext;
}

export const UberPaymentInitialContext: UberPaymentContext = {
  paymentSessionToken: undefined,
  paymentQuoteToken: undefined,
};

export const getPaymentInitialContext = (): PaymentContext => ({
  [PaymentState.payment]: { ...UberPaymentInitialContext },
});
